import { useState } from "react";

const useRegistrationFlowHelpers = ({ price_points }) => {
  const [pricePoints] = useState(Array.isArray(price_points) ? price_points : []);

  const createFullPricePointPositionArray = () =>
      pricePoints.filter(
          (pp) => pp.registration_count >= pp.capacity
      );

  const setFullPricePointFlag = () =>
      pricePoints.some(
          (pp) => pp.registration_count >= pp.capacity
      );

  const createOpenPricePointArray = () =>
      pricePoints.filter(
          (pp) => pp.registration_count < pp.capacity
      );

  const createFullPricePointArray = () =>
      pricePoints.filter(
          (pp) => pp.registration_count >= pp.capacity
      );

  const campFull = () =>
      pricePoints.length > 0 && pricePoints.every(
          (pp) => pp.registration_count >= pp.capacity
      );

  return {
    campFull,
    setFullPricePointFlag,
    createFullPricePointArray,
    createFullPricePointPositionArray,
    createOpenPricePointArray,
  };
};

export default useRegistrationFlowHelpers;
